import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { HttpClient } from '@angular/common/http';
import { inject, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { FilterService } from 'src/app/services/filter.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';

@Component({
    selector: 'app-tree-map-card',
    templateUrl: './tree-map-card.component.html',
    styleUrls: ['./tree-map-card.component.scss'],
    standalone: false
})
export class TreeMapCardComponent implements OnInit {
  private readonly noDataNotifier = inject(NoDataNotifierService);

  static key = 100815;
  
  @Input("item") item: any;
  @Input("pageKey") pageKey: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("treeChartDiv", { static: true }) treeChartDiv!: ElementRef;
  @ViewChild("fs") fs!: ElementRef;
  @HostBinding("class.is-fullscreen") isFullscreen = false;
  isActive = true;
  chartData:any;
  heading:any;
  noData:any;
  loader=true;
  reqSubcription: Subscription[] = [];
  decryptedParams:any;
  clientKey:any;
  moduleKey:any;
  dashboardKey:any;
  chartType = 'parent';
  dynamicCol:any = {};

  excelConfig:any;

  api_key:any;
  groupKey:any;
  previousDayCount:any;
  todayCount:any;
  colorPalette:any;
  error_name:any;
  showByConfig:any;

  constructor(
    private filterService: FilterService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private httpClient: HttpClient
  ) { 
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.loader = true;
        if(this.chartType != 'group') { 
          this.loadApiData();
        } else {
          this.loadGroupApiData();
        }
        
      })
    );
  }

  showBySubs($event:any) {
    this.dynamicCol = this.showByConfig[$event]
  }

  ngOnInit(): void {
    const widgetKey = this.item?.widget_uniq_key || this.item?.key || 'default';
    
    let showByIndex:any = this.filterService.getShowBySelection(widgetKey);
    
    this.route.params.subscribe((p: any) => {
      // this.moduleName = p['module'] || '';
      // this.cardName = p['cardName'] || '';

      this.route.queryParams.subscribe((params: any) => {
        this.decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = this.decryptedParams["cl_key"];
        this.moduleKey = this.decryptedParams["md_key"];
        this.dashboardKey = this.decryptedParams["ds_key"];
      });
    });

    const observer = new ResizeObserver((entries: any) => {
      setTimeout(() => {
        this.onSizeChange.emit(entries[0].contentRect.height);
      }, 0);
    });
    observer.observe(this.treeChartDiv?.nativeElement);

    // this.loadConfiguration();

    let chartType = this.item?.config?.['default_chart_type']?.['value'] || 'normal';

    if(chartType == 'group') { 
      this.chartType = 'group';
      
      if(!this.item.config?.["list_group_of_api"]?.api_key) {
        this.item.config["list_group_of_api"] = {
          api_key : "20016"
        }
      }

      let group_key_parent = this.item?.config?.["group_key_parent"] || [];
      let groupKey = group_key_parent.map((m:any) => m.api_resp_column_nm);
      
      let previousDayCount = this.item?.config?.["prev_day_count_parent"]?.['api_resp_column_nm'] || 'prev_day_count';
      let todayCount = this.item?.config?.["today_count_parent"]?.['api_resp_column_nm'] || 'today_count';
      this.excelConfig = this.item?.config?.["excel_column_parent"] || [];
      this.showByConfig = [
        {
          group_key: ['business_table_name', 'result_typ'],
          today_count: todayCount,
          previous_count: previousDayCount,
          leaf_key: "dqc_col_nm",
          status_key: "result_typ",
          sort_by: "desc",
          group_typ: 'status'
        },
        {
          group_key: ['business_table_name'],
          today_count: todayCount,
          previous_count: previousDayCount,
          leaf_key: "dqc_col_nm",
          status_key: "result_typ",
          sort_by: "desc",
          group_typ: 'count'
        },
        {
          group_key: ['business_table_name'],
          today_count: todayCount,
          previous_count: previousDayCount,
          leaf_key: "dqc_col_nm",
          status_key: "result_typ",
          sort_by: "desc",
          group_typ: 'squence'
        }
      ]
      
      this.dynamicCol = this.showByConfig[showByIndex ?? 0]
      // this.dynamicCol = {
      //   group_key: ['business_table_name', 'result_typ'],
      //   today_count: todayCount,
      //   previous_count: previousDayCount
      // }
      this.colorPalette = {
        FAIL: '#FC5A76',
        ERROR: '#F4D35E',
        WARNING: '#F4A744'
      }
    } else {
      this.loadConfiguration();
      this.parentConfiguration();
    }
  }

  loadConfiguration() {
    let legend_color_config = this.item?.config?.["legend_color_config"]?.values || [];
    this.colorPalette = {};
    legend_color_config.forEach((f:any)=> {
      this.colorPalette[f.col_value] = f.color  
    })

  }

  parentConfiguration() {
    this.api_key = this.item?.config?.["list_of_api_parent"]?.['api_key'] || '20010';
    let group_key_parent = this.item?.config?.["group_key_parent"] || [];
    this.groupKey = group_key_parent.map((m:any) => m.api_resp_column_nm);
    
    this.previousDayCount = this.item?.config?.["prev_day_count_parent"]?.['api_resp_column_nm'] || 'prev_day_count';
    this.todayCount = this.item?.config?.["today_count_parent"]?.['api_resp_column_nm'] || 'today_count';
    this.excelConfig = this.item?.config?.["excel_column_parent"] || [];

    this.chartType = 'parent';

    this.dynamicCol = {
      group_key: this.groupKey,
      today_count: this.todayCount,
      previous_count: this.previousDayCount
    }
  }

  childConfiguration() {
    this.api_key = this.item?.config?.["list_of_api_child"]?.['api_key'] || '20012';
    let group_key_parent = this.item?.config?.["group_key_child"] || [];
    this.groupKey = group_key_parent.map((m:any) => m.api_resp_column_nm);
    
    this.previousDayCount = this.item?.config?.["prev_day_count_child"]?.['api_resp_column_nm'] || 'prev_day_count';
    this.todayCount = this.item?.config?.["today_count_child"]?.['api_resp_column_nm'] || 'today_count';
    this.excelConfig = this.item?.config?.["excel_column_child"] || [];

    this.chartType = 'child';

    this.dynamicCol = {
      group_key: this.groupKey,
      today_count: this.todayCount,
      previous_count: this.previousDayCount
    }
  }

  loadApiData(dynamicPayloads?:any) {
    this.loader = true;
    let api = this.item?.config?.["list_of_api"] || {};

    if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
      
      // API Payload
      let obj: any = {
        api_key: this.api_key || '20010',
        module_key: this.apiService.getModuleKey()
      };
      
      let query = Object.assign({}, this.filterService.baseQuery, obj)

      if(dynamicPayloads) {
        query = Object.assign({}, query, dynamicPayloads)
      }

      query["report_typ"] = this.filterService.report_type || 'D';
      query["module_key"] = this.apiService.getModuleKey();
      
      let endPoint = this.item.config?.["list_of_api_endpoint"];

      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${ endPoint || 'kpi/get-execution-details'}`, query).subscribe((res:any)=> {
          this.chartData = (res == null || res.length==0) ? [] : res;
          // this.chartData = this.rawData;
          if (this.chartData?.length>0) { this.noData = false } else { this.noData = true; this.noDataNotifier.report('tree-map-card') };
          // this.noData = false
          this.loader = false;
          this.error_name = '';
        },(err:any)=>{
          this.chartData = []
          this.noData = true; this.noDataNotifier.report('tree-map-card')
          this.loader = false;
          this.error_name = friendlyApiErrorMessage(err);
        })
      )
    }
  }

  chartTypeEmitter(event:any) {
    this.parentConfiguration();
    this.loadApiData();
  }

  detailTrigger(event:any) {
    if(this.chartType != 'child') {
      let dynamicPayloads = {
        file_type_dim_key: event[0]?.file_type_dim_key || undefined,
        db_schema_key: event[0].db_schema_key || undefined,
        table_name: event[0].business_table_name || undefined
      }
  
      this.childConfiguration();
      this.loadApiData(dynamicPayloads);
    };
  }

  singleClicked(event:any) {
    if(event && event?.[0]) {
      let obj = {
        file_type_dim_key: event?.[0]?.file_type_dim_key || undefined,
        db_schema_key: event?.[0]?.db_schema_key || undefined,
        dqc_col_nm: this.chartType == 'group' ? (event?.[0]?.dqc_col_nm || event?.[0]?.name || undefined) : (event?.[0]?.dqc_col_nm || undefined),
        // table_name: event[0]?.table_name || undefined
        table_name: event[0]?.business_table_name || event[0]?.groupName || undefined,
        defect_type: event[0]?.status ? event[0]?.status.toString() : undefined,
        error_type_code:
          event[0]?.error_type_code
          || event[0]?.error
          || (event[0]?.status ? event[0]?.status.toString() : undefined)
      }
      this.filterService.treeMapSingleClickTrigger.next(obj);
    }
  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

  loadGroupApiData() {
    this.loader = true;
    let api = this.item?.config?.["list_group_of_api"] || {};

    if(this.filterService.isEmptyObject(this.filterService.baseQuery) == false) {
      
      // API Payload
      let obj: any = {
        api_key: api?.api_key || '20016',
        module_key: this.apiService.getModuleKey()
      };
      
      let query = Object.assign({}, this.filterService.baseQuery, obj)

      query["report_typ"] = this.filterService.report_type || 'D';
      query["module_key"] = this.apiService.getModuleKey();
      
      let endPoint = this.item.config?.["list_of_api_endpoint"];

      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${ endPoint || 'kpi/get-execution-details'}`, query).subscribe((res:any)=> {
          this.chartData = (res == null || res.length==0) ? [] : res;
          // this.chartData = this.rawData;
          if (this.chartData?.length>0) { this.noData = false } else { this.noData = true; this.noDataNotifier.report('tree-map-card') };
          // this.noData = false
          this.loader = false;
          this.error_name = '';
        },(err:any)=>{
          this.chartData = []
          this.noData = true; this.noDataNotifier.report('tree-map-card')
          this.loader = false;
          this.error_name = friendlyApiErrorMessage(err);
        })
      )
    }
  }
}
